import { Checkbox, ICheckboxProps } from '@/components/inputs';
import { useWorkspace } from '@/features/workspaces/hooks';
import { useLazyGetDataSourceStatsQuery } from '@/services/dataSources';
import { FC, useEffect } from 'react';
import { Trans } from 'react-i18next';
import { DataSource } from '../../../models/dataSource';

type DefaultProps = ICheckboxProps & React.ComponentProps<'input'>;

type DataSourceCheckboxProps = DefaultProps & {
  dataSource: DataSource;
  traitId?: string;
};

type FormattedDescriptionProps = {
  users: number;
  events: number;
  traits: number;
};

const FormattedDescription: FC<FormattedDescriptionProps> = ({ users, events, traits }) => {
  return (
    <Trans
      i18nKey='audience_edit:audience_details.datasource_stats_v2'
      values={{
        users,
        events,
        traits,
      }}
      components={{
        boldBrand: <span className='font-medium text-brand-600' />,
      }}
    />
  );
};

export const DataSourceCheckbox: FC<DataSourceCheckboxProps> = ({ dataSource, traitId, ...rest }) => {
  const workspace = useWorkspace();

  const [getStats, { isLoading, data }] = useLazyGetDataSourceStatsQuery();

  useEffect(() => {
    getStats({
      workspaceId: workspace.id,
      dataSourceId: dataSource.id,
      traitId,
    });
  }, [traitId]);

  const descriptionElement = data ? <FormattedDescription users={data.users || 0} events={data.events || 0} traits={data.traits || 0} /> : undefined;

  return <Checkbox {...rest} name={dataSource.id} id={dataSource.id} loading={isLoading} label={dataSource.name} description={descriptionElement} />;
};
